'use client';

import { useState, useEffect, useMemo } from 'react';
import Image from 'next/image';
import { useActivityList } from '@/features/activity/store/list';
import { AudioId, useAudioHelper } from '@/utils/audio-hepler';
import { track } from '@/utils/track';
import { usePrefetchActivities } from '@/hooks/use-prefetch-activities';
import { PrefetchLink } from '@/components/prefetch-link';
import { ActivitySourceEnum } from '@/const/report';

const HomeAutoPlayer = () => {
  const { activityList, jumpTo } = useActivityList(ActivitySourceEnum.operation);
  const [currentIndex, setCurrentIndex] = useState(0);
  const displayList = useMemo(() => activityList.slice(0, 3), [activityList]);
  const { playAudio } = useAudioHelper({ id: AudioId.ButtonClick });

  // 使用预加载 hook
  const { getActivityLink } = usePrefetchActivities(
    displayList,
    ActivitySourceEnum.operation,
    { enabled: true, withTab: true }
  );

  useEffect(() => {
    if (displayList.length <= 1) return;

    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % displayList.length);
    }, 3000);

    return () => clearInterval(timer);
  }, [displayList.length]);

  if (displayList.length === 0) return null;

  return (
    // right-[-2px]会导致滚动条 父元素需要加上 overflow hidden
    <div className={'overflow-hidden w-[135px] h-[59px] absolute right-[-2px] top-[-2px] z-50'}>
      <div className="relative w-full h-full">
        {displayList.map((obj, index) => {
          const handleClick = () => {
            jumpTo(obj, true);
            playAudio();
            track('operation_click', {
              button_name: obj?.enName || obj?.name,
            });
          };

          const imageContent = obj.adImage && (
            <Image
              src={obj.adImage}
              alt={`Activity ${index + 1}`}
              className="h-[58px] object-contain"
              height={58}
              width={135}
              priority={index < 2}
            />
          );

          return (
            <div
              key={index}
              className="absolute inset-0 flex items-center justify-center transition-opacity duration-500 cursor-pointer"
              style={{
                opacity: index === currentIndex ? 1 : 0,
                pointerEvents: index === currentIndex ? 'auto' : 'none',
              }}
            >
              <PrefetchLink
                href={getActivityLink(obj)}
                onClick={handleClick}
                className="cursor-pointer flex items-center justify-center w-full h-full"
              >
                {imageContent}
              </PrefetchLink>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HomeAutoPlayer;